import img1 from "./../assets/img/Egresados/1.png";
import img2 from "./../assets/img/Egresados/5.png";
import img3 from "./../assets/img/Egresados/45.png";
import img4 from "./../assets/img/Egresados/44.png";
import img5 from "./../assets/img/Egresados/43.png";
import img6 from "./../assets/img/Egresados/42.png";
import img7 from "./../assets/img/Egresados/41.png";
import img8 from "./../assets/img/Egresados/40.png";
import img9 from "./../assets/img/Egresados/39.png";
import img10 from "./../assets/img/Egresados/38.png";
import img11 from "./../assets/img/Egresados/37.png";
import img12 from "./../assets/img/Egresados/36.png";
import img13 from "./../assets/img/Egresados/35.png";
import img14 from "./../assets/img/Egresados/34.png";
import img15 from "./../assets/img/Egresados/33.png";
import img16 from "./../assets/img/Egresados/32.png";
import img17 from "./../assets/img/Egresados/31.png";
import img18 from "./../assets/img/Egresados/30.png";
import img19 from "./../assets/img/Egresados/29.png";
import img20 from "./../assets/img/Egresados/28.png";
import img21 from "./../assets/img/Egresados/27.png";
import img22 from "./../assets/img/Egresados/26.png";
import img23 from "./../assets/img/Egresados/25.png";
import img24 from "./../assets/img/Egresados/24.png";
import img25 from "./../assets/img/Egresados/23.png";
import img26 from "./../assets/img/Egresados/22.png";
import img27 from "./../assets/img/Egresados/21.png";
import img28 from "./../assets/img/Egresados/20.png";
import img29 from "./../assets/img/Egresados/19.png";
import img30 from "./../assets/img/Egresados/18.png";
import img31 from "./../assets/img/Egresados/17.png";
import img32 from "./../assets/img/Egresados/16.png";
import img33 from "./../assets/img/Egresados/15.png";
import img34 from "./../assets/img/Egresados/14.png";
import img35 from "./../assets/img/Egresados/13.png";
import img36 from "./../assets/img/Egresados/12.png";
import img37 from "./../assets/img/Egresados/11.jpg";
import img38 from "./../assets/img/Egresados/10.png";
import img39 from "./../assets/img/Egresados/9.png";
import img40 from "./../assets/img/Egresados/8.png";
import img41 from "./../assets/img/Egresados/7.png";
import img42 from "./../assets/img/Egresados/6.png";
import img43 from "./../assets/img/Egresados/4.png";
import img44 from "./../assets/img/Egresados/3.png";
import img45 from "./../assets/img/Egresados/2.png";


import { Carousel } from "react-responsive-carousel";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export const Graduates = (props) => {
  return (
    <div id="Graduates">
      <div>
          <Carousel
              showStatus={false}
              showThumbs={false}
              infiniteLoop={true}
              swipeable={true}
              emulateTouch={true}
              renderArrowPrev={(onClickHandler, hasPrev, label) => (
                  <div
                      onClick={onClickHandler}
                      title={label}
                      style={{
                          //ff5500 --> NARANJA
                          color: "#ff5500",
                          position: "absolute",
                          zIndex: 2,
                          top: "calc(50% - 15px)",
                          width: 30,
                          height: 30,
                          cursor: "pointer",
                          left: 15,
                      }}
                  >
                      <FaChevronLeft fontSize={25} className="w-9 h-9 text-white"/>
                  </div>
              )}
              renderArrowNext={(onClickHandler, hasNext, label) => (
                  <div
                      onClick={onClickHandler}
                      title={label}
                      style={{
                          //ff5500 --> NARANJA
                          color: "#ff5500",
                          position: "absolute",
                          zIndex: 2,
                          top: "calc(50% - 15px)",
                          width: 30,
                          height: 30,
                          cursor: "pointer",
                          right: 15,
                      }}
                  >
                      <FaChevronRight fontSize={25} className="w-9 h-9 text-white"/>
                  </div>
              )}
              showIndicators={false}
          >
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img1} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img2} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img3} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img4} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img5} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img6} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img7} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img8} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img9} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img10} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img11} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img12} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img13} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img14} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img15} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img16} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img17} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img18} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img19} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img20} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img21} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img22} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img23} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img24} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img25} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img26} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img27} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img28} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img29} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img30} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img31} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img32} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img33} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img34} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img35} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img36} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img37} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img38} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img39} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img40} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img41} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img42} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img43} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img44} alt=""/>
                      </div>
                  </div>
              </div>
              <div className="graduates-card">
                  <div className="itemGraduate">
                      <div className="containerImage">
                          <img src={img45} alt=""/>
                      </div>
                  </div>
              </div>
          </Carousel>
      </div>
    </div>
  );
};
